// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"styles_wrapper__oV_WB","title":"styles_title__EPtQj","info":"styles_info__ixscw","activationButton":"styles_activationButton__lp4lB","icon":"styles_icon__0X6N2"};
module.exports.__checksum = "66aeb926ffe3"